<template>
  <a-row class="ministry">
    <a-row class="content-title" type="flex">
      <h2 class="flex-1">
        {{ $route.meta.title[$i18n.locale] }}
      </h2>

      <a-row
        class="flex-no__wrap ml-auto wanted-search-input-wrapper"
        type="flex"
        style="justify-content: flex-end"
      />
    </a-row>

    <a-table
      :key="$route.fullPath"
      :columns="columns"
      :data-source="tableProps"
    >
      <template slot="name" slot-scope="item">
        <div
          style="cursor: pointer"
          @click="
            $router.push({
              name: item.name,
              params: { id: item.id },
              query: { type: item.type, title: item.title }
            })
          "
        >
          <b v-if="item.id">({{ item.id }})</b> {{ item.title[$i18n.locale] }}
        </div>
      </template>
    </a-table>
  </a-row>
</template>

<script>
export default {
  data: () => ({
    columns: [
      {
        title: "Название",
        key: "title",
        class: "wanted-fio-td",
        scopedSlots: { customRender: "name" }
      }
    ],
    tableProps: [
      {
        title: {
          oz: "Кунлик қишлоқ хўжалиги маҳсулотлари нархлари",
          uz: "Kunlik qishloq xo'jaligi mahsulotlari narxlari",
          ru: "Ежедневные цены на сельскохозяйственную продукцию",
          en: "Daily prices of agricultural products"
        },
        id: 268,
        name: "posts",
        type: 8
      },
      {
        title: {
          oz: "Янгиликлар",
          uz: "Yangiliklar",
          ru: "Новости",
          en: "News"
        },
        id: 13,
        name: "posts"
      },
      {
        title: {
          oz: "Яшил иқтисодиёт",
          uz: "Yashil iqtisodiyot",
          ru: "Зеленая экономика",
          en: "Green economy"
        },
        id: 52,
        name: "posts"
      },
      {
        title: {
          oz: "Ўзбекистон янгиликлари",
          uz: "O'zbekiston yangiliklari",
          ru: "Новости Узбекистана",
          en: "Uzbekistan news"
        },
        id: 248,
        name: "posts"
      },
      {
        title: {
          oz: "Тадбирлар",
          uz: "Tadbirlar",
          ru: "Мероприятия",
          en: "Events"
        },
        id: 201,
        name: "posts"
      },
      {
        title: {
          oz: "Тадбирлар (Гендер тенглик)",
          uz: "Tadbirlar (Gender tenglik)",
          ru: "Мероприятия (Гендерное равенство)",
          en: "Events (Gender equality)"
        },
        id: 91,
        name: "posts"
      },
      {
        title: {
          oz: "Эълон, анонслар ва шарҳлар",
          uz: "E'lon, anonslar va sharhlar",
          ru: "Объявления, анонсы и обзоры",
          en: "Announcements, announs and reviews"
        },
        id: 202,
        name: "posts"
      },
      {
        title: {
          oz: "Маърузалар ва интервьюлар",
          uz: "Ma'ruzalar va intervyular",
          ru: "Лекции и интервью",
          en: "Lectures and interviews"
        },
        id: 203,
        name: "posts"
      },
      {
        title: {
          oz: "ОАВ биз ҳақимизда",
          uz: "OAV biz haqimizda",
          ru: "СМИ о нас",
          en: "Mass Media about us"
        },
        id: 204,
        name: "posts"
      },
      {
        title: {
          oz: "Эълонлар",
          uz: "E'lonlar",
          ru: "Объявления",
          en: "Announcements"
        },
        id: 146,
        name: "announcements",
        type: 3
      },
      {
        title: {
          oz: "Маънавият ва маърифат",
          uz: "Ma'naviyat va ma'rifat",
          ru: "Духовность и Просветление",
          en: "Spirituality and Enlightenment"
        },
        id: 97,
        name: "posts"
      },
      {
        title: {
          oz: "Коррупцияга қарши курашиш тадбирлари",
          uz: "Korrupsiyaga qarshi kurashish tadbirlari",
          ru: "Антикоррупционные события",
          en: "Anti-corruption events"
        },
        id: 176,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Жаҳон Банки билан қўшма лойиҳалар",
          uz: "Jahon Banki bilan qo'shma loyihalar",
          ru: "Совместные проекты со Всемирным Банком",
          en: "Joint projects with the World Bank"
        },
        id: 458,
        name: "posts"
      },
      {
        title: {
          uz: "Islom taraqqiyot banki bilan qo'shma loyihalar",
          oz: "Ислом тараққиёт банки билан қўшма лойиҳалар",
          ru: "Совместные проекты с Исламским банком развития",
          en: "Joint projects with the Islamic Development Bank"
        },
        id: 600,
        name: "posts"
      },
      {
        title: {
          oz: "Халқаро ҳамкорлик,  семинар ва тренинглар",
          uz: "Xalqaro hamkorlik, seminar va treninglar",
          ru: "Международное сотрудничество, семинары и тренинги",
          en: "International cooperation, seminars and trainings"
        },
        name: "posts",
        id: 378
      },
      {
        title: {
          oz: "Мақолалар (Давлат тилида иш юритиш)",
          uz: "Maqolalar (Davlat tilida ish yuritish)",
          ru: "Статьи (Ведение бизнеса на государственном языке",
          en: "Articles (Operating in the State Language)"
        },
        name: "posts",
        id: 520
      },
      {
        title: {
          oz: "Ташаббусли бюджет",
          uz: "Tashabbusli budjet",
          ru: "Инициативный бюджет",
          en: "Initiative budget"
        },
        name: "posts",
        id: 527
      },

      {
        title: {
          oz: "Гендерга йўналтирилган бюджетлаштириш",
          uz: "Genderga yo'naltirilgan budjetlashtirish",
          ru: "Гендерно-ориентированное бюджетирование",
          en: "Gender-oriented budgeting"
        },
        name: "posts",
        id: 565
      },
      {
        title: {
          en: "Council News",
          ru: "Новости Совета",
          uz: "Kengash yangiliklari",
          oz: "Кенгаш янгиликлари"
        },
        name: "posts",
        id: 579
      },
      // {
      //   title: "Речи министра",
      //   id: 96,
      //   name: "posts"
      // },
      // {
      //   title: "Министр и молодежь",
      //   id: 97,
      //   name: "posts"
      // },
      // {
      //   title: {
      //     oz: "СМИ о нас",
      //     uz: "СМИ о нас",
      //     ru: "СМИ о нас",
      //     en: "СМИ о нас"
      //   },
      //   id: 51,
      //   name: "mass"
      // },
      // {
      //   title: "Медиа план",
      //   id: 53,
      //   name: "mediaplan"
      // },
      // {
      //   title: "Духовность и просвещение",
      //   id: 55,
      //   name: "posts"
      // },
      {
        title: {
          oz: "Фотогаллерея",
          uz: "Fotogalereya",
          ru: "Фотогаллерея",
          en: "Photo gallery"
        },
        name: "gallery"
      },
      {
        title: {
          oz: "Видеогаллерея",
          uz: "Videogalereya",
          ru: "Видеогаллерея",
          en: "Video gallery"
        },
        name: "video"
      },
      {
        title: {
          oz: "Жамоатчилик кенгаши таркиби",
          uz: "Jamoatchilik kengashi tarkibi",
          ru: "Состав Общественного Совета",
          en: "Composition of the Public Council"
        },
        name: "public-council"
      },
      {
        title: {
          oz: "Марказий аппарат",
          uz: "Markaziy apparat",
          ru: "Центральный аппарат",
          en: "Headquarters"
        },
        id: 687,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Қорақалпоғистон Республикаси Иқтисодиёт ва молия вазирлиги",
          uz: "Qoraqalpog‘iston Respublikasi Iqtisodiyot va moliya vazirligi",
          ru: "Министерство экономики и финансов Республики Каракалпакстан",
          en: "Ministry of Economy and Finance of the Republic of Karakalpakstan"
        },
        id: 688,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Андижон вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Andijon viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Андижанской области",
          en: "Andijan Regional Main Department of Economy and Finance"
        },
        id: 689,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Бухоро вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Buxoro viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Бухарской области",
          en: "Bukhara Regional Main Department of Economy and Finance"
        },
        id: 690,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Жиззах вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Jizzax viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Джизакской области",
          en: "Jizzakh Regional Main Department of Economy and Finance"
        },
        id: 691,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Қашқадарё вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Qashqadaryo viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Кашкадарьинской области",
          en: "Kashkadarya Regional Main Department of Economy and Finance"
        },
        id: 692,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Навоий вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Navoiy viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Навоийской области",
          en: "Navoi Regional Main Department of Economy and Finance"
        },
        id: 693,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Наманган вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Namangan viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Наманганской области",
          en: "Namangan Regional Main Department of Economy and Finance"
        },
        id: 694,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Самарқанд вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Samarqand viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Самаркандской области",
          en: "Samarkand Regional Main Department of Economy and Finance"
        },
        id: 701,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Сурхондарё вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Surxondaryo viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Сурхандарьинской области",
          en: "Surkhandarya Regional Main Department of Economy and Finance"
        },
        id: 695,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Сирдарё вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Sirdaryo viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Сирдарьинской области",
          en: "Syrdarya Regional Main Department of Economy and Finance"
        },
        id: 696,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Тошкент вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Toshkent viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Ташкентской области",
          en: "Tashkent Regional Main Department of Economy and Finance"
        },
        id: 697,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Фарғона вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Farg‘ona viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Ферганской области",
          en: "Fergana Regional Main Department of Economy and Finance"
        },
        id: 698,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Тошкент шаҳар Иқтисодиёт ва молия бош бошқармаси",
          uz: "Toshkent shahar Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов города Ташкента",
          en: "Tashkent City Main Department of Economy and Finance"
        },
        id: 699,
        name: "events",
        type: 4
      },
      {
        title: {
          oz: "Хоразм вилояти Иқтисодиёт ва молия бош бошқармаси",
          uz: "Xorazm viloyati Iqtisodiyot va moliya bosh boshqarmasi",
          ru: "Главное управление экономики и финансов Хорезмской области",
          en: "Khorezm Regional Main Department of Economy and Finance"
        },
        id: 700,
        name: "events",
        type: 4
      }

      // {
      //   title: "FAQ",
      //   id: 52,
      //   name: "faq"
      // }
    ]
  }),
  methods: {}
}
</script>

<style>
.wanted-search-input-wrapper {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 430px;
  flex: 0 0 430px;
  justify-content: space-around;
}
/*.ministry .ant-table-pagination.ant-pagination {
  display: none;
}*/
</style>
